
import axios from "axios";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useSincro() {
    const store = useStore(key);

    async function sincronizarDatos() {
        try {
            await axios
                .post(store.state.url + "api/WorkerTrigger/SincronizarDatos", { headers: {} })
                .then((response) => {
                    if (response.status == 200) {
                        console.log("Worker lanzado correctamente");
                    } else {
                        console.log(response.statusText);
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                });
        } catch (error) {
            console.log(error);
        }
    }

    async function sincronizarEmpleadosBuk() {
        try {
            await axios
                .post(store.state.url + "api/WorkerTrigger/SincronizarEmpleados", { headers: {} })
                .then((response) => {
                    if (response.status == 200) {
                        console.log("Worker lanzado correctamente");
                    } else {
                        console.log(response.statusText);
                    }
                })
                .catch(function (error) {
                    console.log(error.message);
                });
        } catch (error) {
            console.log(error);
        }
    }

    return { sincronizarDatos, sincronizarEmpleadosBuk };
}